/* Credit Card Types */
export const CREDIT_CARD_VISA = "VISA";
export const CREDIT_CARD_AMERICAN_EXPRESS = "AMERICAN EXPRESS";
export const CREDIT_CARD_MASTERCARD = "MASTERCARD";
export const CREDIT_CARD_JCB = "JCB";
export const CREDIT_CARD_DISCOVER = "DISCOVER";
export const CREDIT_CARD_DINERS_CLUB = "DINERS CLUB";

/** Map Credit Card Name to Credit Card Type */
export const MAP_CREDIT_CARD = [
    { id: 1,
      name: CREDIT_CARD_VISA
    },
    { id:2,
      name: CREDIT_CARD_MASTERCARD
    }];


// WEBPACK FOOTER //
// ./src/payments/ClaroPagosGate/constants.ts